<template>
  <div class="selectTag">
    <BLM-h4-title v-if="title" :title="title" />
    <div class="checkbox">
      <div class="checkLable">
        <span>{{ labelName }}:</span>
      </div>
      <div v-if="allTagList.length" >
        <el-checkbox-group v-model="checkboxGroup">
          <el-checkbox class="itemLabel" @change="checked => selectTag(checked, item.id)" v-for="item in allTagList" :key="item.id" :label="item.name" border :value="item.id"></el-checkbox>
        </el-checkbox-group>
      </div>
      <div v-else>暂无数据</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectTag',
  model: {
    prop: 'tagList',
    event: 'change',
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    labelName: {
      type: String,
      default: '可添加标签',
    },
    allTagList: {
      type: Array,
      default: () => [],
    },
    currentTagList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      checkboxGroup: [],
      checkedIds: new Set(),
    }
  },
  watch: {
    currentTagList: {
      handler(val) {
        this.checkboxGroup = []
        this.checkedIds.clear()
        val.forEach((element) => {
          this.allTagList.forEach((item) => {
            if (element.id === item.id) {
              this.checkboxGroup.push(item.name)
              this.checkedIds.add(item.id)
            }
          })
        })
        this.$emit('change', [...this.checkedIds])
      },
      deep: true,
    },
    allTagList: {
      handler(val) {
        this.checkboxGroup = []
        this.checkedIds.clear()
        this.currentTagList.forEach((element) => {
          val.forEach((item) => {
            if (element.id === item.id) {
              this.checkboxGroup.push(item.name)
              this.checkedIds.add(item.id)
            }
          })
        })
        this.$emit('change', [...this.checkedIds])
      },
      deep: true,
    },
  },
  methods: {
    selectTag(checked, id) {
      if (checked) {
        this.checkedIds.add(id)
      } else {
        this.checkedIds.delete(id)
      }
      this.$emit('change', [...this.checkedIds])
    },
  },
}
</script>

<style lang="scss" scoped>
.selectTag{
  .checkbox{
    display: flex;
    align-items: center;
    padding-bottom: 6px;

    .checkLable{
      width: 100px;
      padding: 0 12px;
      word-break: keep-all;
    }

    .el-checkbox{
      margin: 0 10px 10px;
    }
  }
}
</style>
